var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--about-us_teams-startup-section teams-startup-section-wrapper py-20 py-md-30 py-lg-40 px-20 px-md-30"
  }, [_c('div', {
    staticClass: "new-container mx-auto"
  }, [_c('div', {
    staticClass: "teams-startup-section-container"
  }, [false ? _c('h2', {
    staticClass: "teams-startup-section-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('components.about.us.teams.team-startups-title')) + "\n      ")]) : _vm._e(), _vm._v(" "), false ? _c('p', {
    staticClass: "teams-startup-section-subtitle"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('components.about.us.teams.team-startups-subtitle')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-w-full tw-justify-center tw-items-start tw-flex-wrap tw-gap-5 md:tw-gap-7.5"
  }, _vm._l(_vm.boxItems, function (boxItem, key) {
    return _c('div', {
      key: `teams-startup-section-box-${key}`,
      staticClass: "teams-startup-section-box"
    }, [boxItem.title ? _c('p', {
      staticClass: "teams-startup-section-box-title"
    }, [_vm._v("\n            " + _vm._s(boxItem.title) + "\n          ")]) : _vm._e(), _vm._v(" "), boxItem.subtitle ? _c('p', {
      staticClass: "teams-startup-section-box-subtitle"
    }, [_vm._v("\n            " + _vm._s(boxItem.subtitle) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('a-icon', {
      staticClass: "tw-block sm:tw-hidden",
      attrs: {
        "type": "class",
        "loader": "raw",
        "name": "website-expansion-content-box-bg-sm"
      }
    }), _vm._v(" "), _c('a-icon', {
      staticClass: "tw-hidden sm:tw-block",
      attrs: {
        "type": "class",
        "loader": "raw",
        "name": "website-expansion-content-box-bg"
      }
    })], 1);
  }), 0)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }